import { useEffect, useState } from "react";

export const LIVE_REFRESH_INTERVAL_MS = 30_000;

/** Age heartbeat badges even when the server returns structurally identical rows. */
export function useLiveNow(): number {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const update = () => setNow(Date.now());
    const timer = window.setInterval(update, LIVE_REFRESH_INTERVAL_MS);
    document.addEventListener("visibilitychange", update);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", update);
    };
  }, []);
  return now;
}
